export default __webpack_public_path__ + "static/media/home_background2.7b08b944.png";